<template>
    <div>
        <img src="../assets/img/fanhui.png" alt="" class="fanhuiBtn" @click="fanhui">
        <img :src="message.banner" alt="" class="topbanner">
        <div class="maincontent">
            <p class="title">
                <img :src="message.yingwen" alt=""><br>
                <span class="span"
                    :class="message.name == 'duobaan' ? 'duobaan' : message.name == 'hemei' ? 'hemei' : message.name == 'jiayi' ? 'jiayi' : message.name == 'jiayue' ? 'jiayue' : message.name == 'jingxuan' ? 'jingxuan' : message.name == 'jingsu' ? 'jingsu' : message.name == 'junlan' ? 'junlan' : message.name == 'qingju' ? 'qingju' : message.name == 'wendu' ? 'wendu' : message.name == 'yiting' ? 'yiting' : ''">加盟申请</span>
            </p>
            <div class="biaodan">
                <p class="name">
                    <img src="../assets/img/Join/name.png" alt="">
                    <input type="text" placeholder="申请人姓名" v-model="ruleForm.name">
                </p>
                <p class="phone">
                    <img src="../assets/img/Join/phone.png" alt="">
                    <input type="number" placeholder="手机号码" v-model="ruleForm.phone">
                </p>
                <p class="yanzheng">
                    <img src="../assets/img/Join/yanzheng.png" alt="">
                    <input type="number" placeholder="验证码" v-model="ruleForm.smsCode">
                    <button
                        :class="message.name == 'duobaan' ? 'duobaan' : message.name == 'hemei' ? 'hemei' : message.name == 'jiayi' ? 'jiayi' : message.name == 'jiayue' ? 'jiayue' : message.name == 'jingxuan' ? 'jingxuan' : message.name == 'jingsu' ? 'jingsu' : message.name == 'junlan' ? 'junlan' : message.name == 'qingju' ? 'qingju' : message.name == 'wendu' ? 'wendu' : message.name == 'yiting' ? 'yiting' : ''"
                        @click="getverificationCode" :disabled="btnOptFlag">{{ btnOptFlag ? outTime : codeBtnText
                        }}</button>
                </p>
                <p class="city">
                    <img src="../assets/img/Join/didian.png" alt="" class="didian">
                    <el-cascader ref="cascaderRef" size="medium" type="text" :options="options" @change="handleChange"
                        placeholder="请选择加盟城市" v-model="city" clearable>
                    </el-cascader>
                </p>
                <div class="qudao">
                    <p class="subtitle">
                        <img src="../assets/img/Join/qudao.png" alt="" class="tubiao">
                        <span>获知加盟的渠道</span>
                    </p>
                    <div class="jutiqudao">
                        <ul>
                            <li>
                                <div>
                                    <el-radio v-model="ruleForm.channel" label="山东文旅酒店集团官网">山东文旅酒店集团官网</el-radio>
                                </div>
                                <div>
                                    <el-radio v-model="ruleForm.channel" label="朋友介绍">朋友介绍</el-radio>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <el-radio v-model="ruleForm.channel" label="百度搜索引擎">百度搜索引擎</el-radio>
                                </div>
                                <div>
                                    <el-radio v-model="ruleForm.channel" label="抖音">抖音</el-radio>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <el-radio v-model="ruleForm.channel" label="微博">微博</el-radio>
                                </div>
                                <div>
                                    <el-radio v-model="ruleForm.channel" label="朋友圈">朋友圈</el-radio>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <el-radio v-model="ruleForm.channel" label="微信公众号">微信公众号</el-radio>
                                </div>
                                <div>
                                    <el-radio v-model="ruleForm.channel" label="加盟招商展">加盟招商展</el-radio>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <el-radio v-model="ruleForm.channel" label="其他">其他</el-radio>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <p class="submit">
                    <button
                        :class="message.name == 'duobaan' ? 'duobaan' : message.name == 'hemei' ? 'hemei' : message.name == 'jiayi' ? 'jiayi' : message.name == 'jiayue' ? 'jiayue' : message.name == 'jingxuan' ? 'jingxuan' : message.name == 'jingsu' ? 'jingsu' : message.name == 'junlan' ? 'junlan' : message.name == 'qingju' ? 'qingju' : message.name == 'wendu' ? 'wendu' : message.name == 'yiting' ? 'yiting' : ''"
                        @click="submitInformation">提交申请</button>
                </p>
                <p class="jiamengrexian"
                    :class="message.name == 'duobaan' ? 'duobaan' : message.name == 'hemei' ? 'hemei' : message.name == 'jiayi' ? 'jiayi' : message.name == 'jiayue' ? 'jiayue' : message.name == 'jingxuan' ? 'jingxuan' : message.name == 'jingsu' ? 'jingsu' : message.name == 'junlan' ? 'junlan' : message.name == 'qingju' ? 'qingju' : message.name == 'wendu' ? 'wendu' : message.name == 'yiting' ? 'yiting' : ''">
                    加盟热线：{{ message.rexian }}</p>
            </div>
        </div>
        <div class="footer">
            <img src="../assets/img/Join/logo.png" alt="">
        </div>
    </div>
</template>

<script>
import { regionData } from 'element-china-area-data'
export default {
data() {
return {
options: regionData,
selectedOptions: [],
message: {},
ruleForm: {
name: '',
phone: '',
city: '',
channel: '',
smsCode: ''
},
city: '',
btnOptFlag: false,// 获取验证码按钮禁用标识
codeBtnText: '获取验证码',
outTime: 60, // 设置发送验证码倒计时时间
timer: null,
telnum: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/, // 验证手机号的正则
}
},

mounted() {
this.message = JSON.parse(sessionStorage.getItem('message'))
},
methods: {
fanhui() {
this.$router.go(-1)
},
handleChange() {
let citys = this.$refs.cascaderRef.getCheckedNodes()[0].pathLabels
if (citys[1] == '市辖区') {
let city = citys[0] + citys[2]
this.ruleForm.city = city
} else {
let city = citys[0] + citys[1] + citys[2]
this.ruleForm.city = city
}
},
// 获取短信验证码
getverificationCode() {
if (this.ruleForm.phone == '') {
this.$message.error('请输入手机号');
} else if (!this.telnum.test(this.ruleForm.phone)) {
this.$message.error('手机号格式不正确');
} else if (this.telnum.test(this.ruleForm.phone)) {
if (this.btnOptFlag) return
this.btnOptFlag = true // 禁用发送验证码按钮
let phone = {
phone: this.ruleForm.phone
}
this.$api.post('/home/sendSms', this.$qs.stringify(phone), (res) => {
console.log(res);
if (res.code == 0) {
this.$message.success(res.msg);
} else {
this.$message.error(res.msg);
}
})
if (!this.timer) {
this.timer = setInterval(() => {
this.outTime = this.outTime - 1
if (this.outTime < 0) {
// 倒计时结束，重置时间器clearInterval(this.timer)
clearInterval(this.timer)
this.codeBtnText = '获取验证码'
this.outTime = 60
this.timer = false
this.btnOptFlag = false
}
}, 1000)
// 每秒执行一次
}
}
},
// 提交加盟信息
submitInformation() {
// console.log(this.ruleForm);
this.$api.post('/home/addHotelApplication', this.$qs.stringify(this.ruleForm), (res) => {
console.log(res);
if (res.code == 0) {
this.$message.success(res.msg);
this.ruleForm = {
name: '',
phone: '',
city: '',
channel: '',
smsCode: ''
}
this.city = ''
this.codeBtnText = '获取验证码'
this.outTime = 60
this.timer = false
this.btnOptFlag = false
} else {
this.$message.error(res.msg);
}
})
}
}
}
</script>

<style lang="less" scoped>
p {
    margin: 0;
}

.fanhuiBtn {
    z-index: 1000;
    position: absolute;
    width: 48px;
    height: 48px;
    top: 20px;
    left: 20px;
}

input {
    border-width: 1.5px;
    border-color: black;
}

.topbanner {
    width: 100%;
}

.maincontent {
    width: 100%;
    height: auto;
    background-color: #ffffff;
    box-shadow: 0px 4px 16px 0px rgba(153, 153, 153, 0.24);
    border-radius: 30px 30px 0 0;
    position: relative;
    margin-top: -30px;
    z-index: 1000;

    .title {
        text-align: center;
        padding-top: 58px;

        img {
            width: 477px;
            height: 30px;
        }

        .span {
            font-family: 'pfct';
            font-size: 40px;
            letter-spacing: 2px;
        }

        .duobaan {
            color: #541b86;
        }

        .hemei {
            color: #17586d;
        }

        .jiayue {
            color: #000000;
        }

        .qingju {
            color: #2eb6aa;
        }

        .wendu {
            color: #3a587e;
        }

        .yiting {
            color: #957f66;
        }

        .jingxuan {
            color: #e1c39b;
        }

        .jiayi {
            color: #23b3d3;
        }

        .jingsu {
            color: #199bc9;
        }

        .junlan {
            color: #b28247;
        }
    }

    .biaodan {
        margin: 0 30px;
        margin-top: 37px;

        p {
            width: 100%;
        }

        .name {
            position: relative;

            img {
                width: 44px;
                height: 44px;
                position: absolute;
                top: 50%;
                left: 30px;
                margin-top: -22px;
            }

            input {
                width: 98%;
                height: 79px;
                border-radius: 10px;
                font-size: 27px;
                color: #999999;
                text-indent: 95px;
            }
        }

        .phone {
            position: relative;
            margin-top: 50px;

            img {
                width: 28px;
                height: 44px;
                position: absolute;
                top: 50%;
                left: 38px;
                margin-top: -22px;
            }

            input {
                width: 98%;
                height: 79px;
                border-radius: 10px;
                font-size: 27px;
                color: #999999;
                text-indent: 95px;
            }
        }

        .yanzheng {
            position: relative;
            margin-top: 50px;

            img {
                width: 23px;
                height: 43px;
                position: absolute;
                top: 50%;
                left: 40px;
                margin-top: -21.5px;
            }

            input {
                width: 50%;
                height: 79px;
                border-radius: 10px;
                font-size: 27px;
                color: #999999;
                text-indent: 103px;
                vertical-align: middle;
            }

            button {
                vertical-align: middle;
                margin-left: 8%;
                width: 40%;
                height: 79px;
                line-height: 79px;
                border-radius: 10px;
                font-family: 'pfzd';
                font-size: 27px;
                letter-spacing: 1px;
                color: #ffffff;
                border: none;
            }

            .duobaan {
                background-color: #541b86;
            }

            .hemei {
                background-color: #17586d;
            }

            .jiayue {
                background-color: #000000;
            }

            .qingju {
                background-color: #2eb6aa;
            }

            .wendu {
                background-color: #3a587e;
            }

            .yiting {
                background-color: #957f66;
            }

            .jingxuan {
                background-color: #e1c39b;
            }

            .jiayi {
                background-color: #23b3d3;
            }

            .jingsu {
                background-color: #199bc9;
            }

            .junlan {
                background-color: #b28247;
            }
        }

        .city {
            margin-top: 50px;
            position: relative;

            .didian {
                width: 28px;
                height: 40px;
                position: absolute;
                top: 50%;
                margin-top: -20px;
                left: 37px;
                z-index: 1000;
            }

            /deep/.el-cascader {
                width: 100%;
                height: 79px !important;
                line-height: 79px !important;

                .el-input {
                    height: 79px !important;
                    line-height: 79px !important;

                    .el-input__inner {
                        height: 79px !important;
                        line-height: 79px !important;
                        text-indent: 90px;
                        font-size: 27px;
                        color: #999999;
                        border-color: black;
                        border-width: 1.5px;
                        border-radius: 10px;
                    }
                }
            }
        }

        .qudao {
            width: 100%;
            margin-top: 50px;
            border-radius: 10px;
            border: solid 1px #2c3e3c;

            .subtitle {
                padding: 26px 0 0 30px;

                .tubiao {
                    width: 41px;
                    height: 39px;
                    vertical-align: middle;
                    margin-right: 32px;
                }

                span {
                    vertical-align: middle;
                    font-family: 'pfzd';
                    font-size: 27px;
                    color: #999999;
                }
            }

            .jutiqudao {
                width: 100%;
                margin-top: 44px;

                ul {
                    padding: 0 121px 36px 80px;

                    li {
                        width: 100%;
                        margin-top: 26px;

                        div:first-child {
                            width: 60%;
                            margin-right: 10%;
                        }

                        div:last-child {
                            width: 30%;
                        }

                        div {
                            display: inline-block;
                            vertical-align: middle;

                            /deep/.el-radio {
                                .el-radio__input {
                                    vertical-align: middle;

                                    .el-radio__inner {
                                        width: 30px;
                                        height: 30px;
                                    }
                                }

                                .el-radio__label {
                                    vertical-align: middle;
                                    font-family: 'pfzd';
                                    font-size: 24px;
                                    color: #4d4d4d;
                                }
                            }
                        }
                    }
                }
            }
        }

        .submit {
            text-align: center;
            margin-top: 61px;

            button {
                width: 450px;
                height: 79px;
                border-radius: 10px;
                margin: 0 auto;
                font-family: 'pfzd';
                font-size: 36px;
                letter-spacing: 1px;
                color: #ffffff;
                border: none;
            }

            .duobaan {
                background-color: #541b86;
            }

            .hemei {
                background-color: #17586d;
            }

            .jiayue {
                background-color: #000000;
            }

            .qingju {
                background-color: #2eb6aa;
            }

            .wendu {
                background-color: #3a587e;
            }

            .yiting {
                background-color: #957f66;
            }

            .jingxuan {
                background-color: #e1c39b;
            }

            .jiayi {
                background-color: #23b3d3;
            }

            .jingsu {
                background-color: #199bc9;
            }

            .junlan {
                background-color: #b28247;
            }
        }

        .jiamengrexian {
            margin-top: 38px;
            text-align: center;
            font-family: 'pfzd';
            font-size: 28px;
            letter-spacing: 1px;
            padding-bottom: 38px;
        }

        .duobaan {
            color: #541b86;
        }

        .hemei {
            color: #17586d;
        }

        .jiayue {
            color: #000000;
        }

        .qingju {
            color: #2eb6aa;
        }

        .wendu {
            color: #3a587e;
        }

        .yiting {
            color: #957f66;
        }

        .jingxuan {
            color: #e1c39b;
        }

        .jiayi {
            color: #23b3d3;
        }

        .jingsu {
            color: #199bc9;
        }

        .junlan {
            color: #b28247;
        }
    }
}

.footer {
    text-align: center;
    height: 100px;
    margin-top: 50px;

    img {
        width: 504px;
        height: 54px;
    }
}
</style>